// actions
const SET = "planItems/SET";
const SET_SELECTED = "planItems/SET_SELECTED";
const SET_SEARCH_TEXT = "planItems/SET_SEARCH_TEXT";
const SET_SAVE_CHANGES = "planItems/SET_SAVE_CHANGES";

const DEFAULT_STATE = {
  listing: [],
  searchText: "",
  selected: "",
  saveChanges: false,
};

// reducer
const reducer = (state = DEFAULT_STATE, action: any = {}) => {
  switch (action.type) {
    case SET:
      return Object.assign({}, state, { listing: action.listing });
    case SET_SEARCH_TEXT:
      return Object.assign({}, state, { searchText: action.searchText });
    case SET_SELECTED:
      return Object.assign({}, state, { selected: action.id });
    case SET_SAVE_CHANGES:
      return Object.assign({}, state, { saveChanges: action.flag });
    default:
      return state;
  }
};

export default reducer;

// action creators
export const setListing = (listing: any[]) => ({ listing, type: SET });
export const setSelected = (id: string) => ({ id, type: SET_SELECTED });
export const setSearchText = (searchText: string) => ({
  searchText,
  type: SET_SEARCH_TEXT,
});
export const setSaveChanges = (flag: boolean) => ({
  flag,
  type: SET_SAVE_CHANGES,
});
